import Super from '../../core/button.gjs';
import styles from './ghost.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Ghost',
  description: `
    Ghost button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Ghost Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/ghost.gjs',
  },
};

export default class SpdsActionButtonGhost extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-ghost';
  variantStyles = styles;
}

export const ACTION_BUTTON_GHOST_METADATA = SpdsActionButtonGhost.metadata;
